import React from 'react';
import { IconProps } from '.';

const SvgPerson = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M16.5 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-1.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM19.216 13h-14.3L2 22h20l-2.784-9Zm.75 7.5-1.856-6H6.007l-1.944 6h15.903Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgPerson;
